import { Controller } from '@hotwired/stimulus'

// Поле «Город» в форме создания матча (account/matches/new.slim) — то же
// устройство, что у tournament_club_controller.js (клубы в конструкторе
// турниров), но выбор пишет ещё и id в скрытое поле: клуб хранится строкой
// по имени, а городу нужна настоящая ссылка (city_id) — ради часового пояса
// на странице матча (UserMatch#local_starts_at).
export default class MatchCityController extends Controller {
  static targets = ['input', 'hiddenId', 'dropdown']
  static values = { url: String }

  connect() {
    this.onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    document.addEventListener('click', this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
    clearTimeout(this.timer)
  }

  // Ручная правка текста делает прежний выбор недостоверным: id мог
  // указывать на город с другим написанием.
  inputChanged() {
    this.hiddenIdTarget.value = ''
    this.search()
  }

  search() {
    clearTimeout(this.timer)
    // Любое изменение текста обесценивает запрос в полёте: иначе при
    // сокращении до одного символа его ответ снова раскрыл бы старые города.
    this.lastRequestId = (this.lastRequestId || 0) + 1
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.close()
      return
    }
    this.timer = setTimeout(() => this.fetchSuggestions(query), 300)
  }

  async fetchSuggestions(query) {
    const requestId = this.lastRequestId
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      if (requestId !== this.lastRequestId || !response.ok) return

      const data = await response.json()
      if (requestId !== this.lastRequestId) return
      this.render(data.suggestions || [])
    } catch {
      if (requestId === this.lastRequestId) this.close()
    }
  }

  render(suggestions) {
    if (!suggestions.length) {
      this.close()
      return
    }

    this.dropdownTarget.innerHTML = ''
    suggestions.forEach(({ id, name, label }) => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'tournament-club-suggestion'
      item.textContent = label
      item.addEventListener('click', () => {
        this.inputTarget.value = name
        this.hiddenIdTarget.value = id
        this.close()
      })
      this.dropdownTarget.appendChild(item)
    })
    this.dropdownTarget.classList.remove('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
    this.dropdownTarget.innerHTML = ''
  }
}
